/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IConverterResult, IVisitorContext } from '../types/tableVisualizationConverterTypes';
import defaultVisitMultiLevelDatasetNode from '../../../../store/util/visitMultiLevelDatasetNode';
import { visitorFactory as defaultVisitorFactory } from './visitorFactory';
import defaultVisitorContextFactory from './visitorContextFactory';
import { IMultiLevelDatasetNode, IMultiLevelDatasetVisitor, } from '../../../../store/types/MultiLevelDatasetTypes';
import { ITableVisualizationWrapperProps } from '../types/tableVisualizationTypes';

export interface ITableVisualizationConverterFactoryTypes {
    visitMultiLevelDatasetNode(node: IMultiLevelDatasetNode, visitor: IMultiLevelDatasetVisitor<IVisitorContext>,
                               context: IVisitorContext): IVisitorContext,
    visitorFactory: {
        create(props: ITableVisualizationWrapperProps): IMultiLevelDatasetVisitor<IVisitorContext>
    },
    visitorContextFactory: {
        create(props: ITableVisualizationWrapperProps): IVisitorContext
    }
}

export function tableVisualizationConverterFactory(tableVisualizationConverterFactoryDeps: ITableVisualizationConverterFactoryTypes) {
    return function convert(props: ITableVisualizationWrapperProps): IConverterResult {
        const { dataset } = props;

        const {
            visitMultiLevelDatasetNode,
            visitorFactory,
            visitorContextFactory
        } = tableVisualizationConverterFactoryDeps;

        const visitor = visitorFactory.create(props);
        const visitorContext = visitorContextFactory.create(props);

        const { missingIndex, table } = visitMultiLevelDatasetNode(
            dataset.data,
            visitor,
            visitorContext
        );

        return { table, missingIndex };
    }
}

export const tableVisualizationConverter = tableVisualizationConverterFactory({
    visitMultiLevelDatasetNode: defaultVisitMultiLevelDatasetNode,
    visitorFactory: defaultVisitorFactory,
    visitorContextFactory: defaultVisitorContextFactory
});
